var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true
      ? _c("div", { staticClass: "row p-l15-r15 p-t20" }, [
          _vm._m(0),
          _vm._m(1),
          _c("div", { staticClass: "row p-t10-b10" }, [
            _c("div", { staticClass: "col-lg-5 col-md-5 col-sm-1 col-xs-1" }),
            _c(
              "div",
              { staticClass: "col-lg-2 col-md-2 col-sm-10 col-xs-10" },
              [
                _c("div", { staticClass: "circle" }, [
                  _vm.kitClassSummary.classCode === "Not Applicable"
                    ? _c("span", { staticClass: "class-code-style" }, [
                        _vm._v("NA"),
                      ])
                    : _c(
                        "span",
                        {
                          class: {
                            "class-code-style class-code-style-font":
                              _vm.kitClassSummary.classCodePfx !== "AIMD",
                            "class-code-style class-code-style-font-small":
                              _vm.kitClassSummary.classCodePfx === "AIMD",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.kitClassSummary.classCodeSfx
                                ? _vm.kitClassSummary.classCodeSfx
                                : _vm.kitClassSummary.classCodePfx
                            )
                          ),
                        ]
                      ),
                ]),
              ]
            ),
            _c("div", { staticClass: "col-lg-5 col-md-5 col-sm-1 col-xs-1" }),
          ]),
          _vm._m(2),
          _c("div", { staticClass: "row p-t10-b10" }, [
            _c(
              "div",
              { staticClass: "col-sm-offset-4 col-md-4 col-sm-4 col-xs-12" },
              [
                _c("div", { staticClass: "class-suggestion-notes" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.prodClassCriteria.country) +
                      " classification is based on inputs provided. "
                  ),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-offset-4 col-md-4 col-sm-4 col-xs-12" },
              [
                _c("div", {
                  staticClass: "class-notes",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.summarizedRiskClassRules.resultingRiskClass[1]
                    ),
                  },
                }),
              ]
            ),
          ]),
          _c("br"),
          _vm.prodClassCriteria.country === "EU IVDR" &&
          _vm.sortedLevelArrayKitSize === 1
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-sm-offset-4 col-md-4 col-sm-4 col-xs-12",
                  },
                  [
                    _c("div", { staticClass: "class-notes" }, [
                      _vm._v(_vm._s(_vm.pageConfig.IVDRClassificationNote)),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true
      ? _c("div", { staticClass: "row" }, [_vm._m(3)])
      : _vm._e(),
    _vm.prodClassCriteria.country === "EU MDR" ||
    _vm.prodClassCriteria.country === "EU IVDR"
      ? _c("div", [
          _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-12 col-md-12 col-sm-12 col-xs-12 heading",
                  },
                  [_vm._v("For Purchase")]
                ),
              ])
            : _vm._e(),
          _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true
            ? _c("div", { staticClass: "row alert-detail p-t10-b10" }, [
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block prev-slide emergo-blue-button float-right m-t5",
                        on: {
                          click:
                            this.$parent
                              .checkMarketPlaceWrapperForRationaleReport,
                        },
                      },
                      [_vm._v("Rationale Report")]
                    ),
                  ]
                ),
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
              ])
            : _vm._e(),
          _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true
            ? _c("div", { staticClass: "row alert-detail p-t10-b10" }, [
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block emergo-blue-button float-right prev-slide",
                        attrs: { id: "mktPlaceProdClassTwo" },
                        on: { click: _vm.regPathwayRouterWrapper },
                      },
                      [_vm._v("Regulatory Essentials Report")]
                    ),
                  ]
                ),
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true &&
    _vm.prodClassCriteria.current_slide_number === 3
      ? _c("div", { staticClass: "disclaimer margin_top_bottom_15" }, [
          _c("br"),
          _vm._v(
            "Disclaimer: This assesment is not intended to replace an in-depth analysis of your company's circumstances, replace a gap analysis or discourage or prevent you or your company from taking appropriate and timely action. Reports are general in nature, not individualized to any particular product or manufacturer, and do not constitute a definitive or comprehensive statement of regulatory information. Emergo by UL is separately available to provide consulting services with respect to the regulatory processes applicable to particular products in specific markets. "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row p-t10-b10" }, [
      _c(
        "div",
        { staticClass: "col-sm-offset-4 col-md-4 col-sm-4 col-xs-12" },
        [
          _c("div", { staticClass: "class-suggestion-notes" }, [
            _c("span", { staticClass: "class-super-heading-notes" }, [
              _vm._v("Your Results"),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row p-t10-b10" }, [
      _c(
        "div",
        { staticClass: "col-sm-offset-4 col-md-4 col-sm-4 col-xs-12" },
        [
          _c("div", { staticClass: "class-suggestion-notes" }, [
            _c("span", { staticClass: "class-header" }, [_vm._v("Class")]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row p-t10-b10" }, [
      _c(
        "div",
        { staticClass: "col-sm-offset-4 col-md-4 col-sm-4 col-xs-12" },
        [_c("div", { staticClass: "hr" }, [_c("hr")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 col-ms-12 col-xs-12" }, [
      _c("div", { staticClass: "hr-thin" }, [_c("hr")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }